import './App.css';
import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";

import MainPage from "./pages/MainPage/MainPage";
import Presentation from "./pages/Presentation/Presentation";
import UnduraCore from "./pages/UnduraCore/UnduraCore";
import ForDonors from "./pages/ForDonors/ForDonors";
import ForOrganizations from "./pages/ForOrganizations/ForOrganizations";
import Platforms from "./pages/Platforms/Platforms";
import ForIssuers from "./pages/ForIssuers/ForIssuers";
import ForInvestors from "./pages/ForInvestors/ForInvestors";
import PageLoader from "./pages/components/PageLoader";

import "./pages/MainPage/mainPageStyle.css";
import "./styles/projectStyles.css";
import DemoPage from "./pages/DemoPage/DemoPage";
import ArchitecturePage from "./pages/ArchitecturePage/ArchitecturePage";
import ResourcesPage from "./pages/ResourcesPage/ResourcesPage";
import CoreLoader from "./pages/components/CoreLoader/CoreLoader";
import axios from "axios";


function App() {


    const [loading, setLoading] = useState(true);
    const location = useLocation();

    const pageLoaderPages = ["/", "/presentation"];
    const coreLoaderPages = ["/core"];

    const showPageLoader = pageLoaderPages.includes(location.pathname);
    const showCoreLoader = coreLoaderPages.includes(location.pathname);

    const showAnyLoader = showPageLoader || showCoreLoader;

    useEffect(() => {
        if (!showAnyLoader) return;

        const alreadyLoaded = sessionStorage.getItem("fontsLoaded");

        const loadFontsAndDelay = async () => {
            if (!alreadyLoaded && document.fonts) {
                try {
                    await document.fonts.ready;
                } catch (e) {}
            }

            await new Promise((resolve) => setTimeout(resolve, 1000));

            sessionStorage.setItem("fontsLoaded", "true");
            setLoading(false);
        };

        loadFontsAndDelay();
    }, [showAnyLoader]);

    return (
        <div className="App">
            {/* PageLoader */}
            {showPageLoader && (
                <PageLoader
                    visible={loading}
                    onFinish={() => setLoading(false)}
                />
            )}

            {/* CoreLoader */}
            {showCoreLoader && (
                <CoreLoader
                    visible={loading}
                    onFinish={() => setLoading(false)}
                />
            )}

            <Routes>
                <Route element={<MainPage />} path="/" index/>
                <Route element={<Presentation />} path="/presentation"/>
                <Route element={<ForDonors />} path="/for-donors" />
                <Route element={<ArchitecturePage />} path="/architecture" />
                <Route element={<ResourcesPage />} path="/resources" />
                <Route element={<ForOrganizations />} path="/for-organizations" />
                <Route element={<DemoPage />} path="/demo" />
                <Route element={<Platforms />} path="/platforms" />
                <Route element={<UnduraCore />} path="/core" />
                <Route element={<ForIssuers />} path="/for-issuers" />
                <Route element={<ForInvestors />} path="/for-investors" />
            </Routes>
        </div>
    );
}


export default App;
